// User Authentication Status Component
import { googleAuthService, authGuardService } from '../services/auth/index.js';

export class UserAuthComponent {
  constructor() {
    this.currentUser = null;
    this.setupAuthStateListener();
  }

  setupAuthStateListener() {
    googleAuthService.onAuthStateChanged((isSignedIn, userInfo) => {
      this.currentUser = userInfo;
      // No UI updates needed - user info is now shown in settings page
    });
  }

  getCurrentUser() {
    return this.currentUser;
  }

  async signOut() {
    try {
      await authGuardService.signOut();
      window.location.reload(); // Reload to restart auth flow
    } catch (error) {
      console.error('Sign out failed:', error);
      throw error;
    }
  }
}

// Create global instance
export const userAuthComponent = new UserAuthComponent();